import React from 'react';
import {ProgressSpinner} from "primereact/progressspinner";

const AuthLoader = () => {
    // return (
    //     <div>
    //         <ProgressSpinner />
    //     </div>

    return (
        <div className="flex align-items-center justify-content-center" style={{minHeight: "100vh"}}>

                {/*<i className="pi pi-spin pi-spinner text-4xl text-primary mb-3" />*/}
                {/*<p className="text-600 m-0">Loading page...</p>*/}
                <ProgressSpinner />

        </div>
    );
    // );
};

export default AuthLoader;